/**
 * Event name: `clock.time`
 *
 * The server time the `clock` SSE topic last reported, as epoch milliseconds.
 *
 * Published so consumers that only need to know *when it is* — whether the
 * market is trading, say — can read it off the bus instead of injecting
 * `AppClockService` and, through it, the SSE and auth stack. The header is what
 * holds the connection open; everyone else listens.
 */
export const CLOCK_EVENTS = {
	TIME: 'clock.time'
} as const;

export type ClockTimeEvent = number;
